import dayjs from "dayjs";

// Período default do filtro de data do dashboard LNO: últimos 24 meses, mês atual incluído.
export const MESES_PERIODO_PADRAO = 24;

export function periodoPadrao() {
  return {
    dataInicio: dayjs()
      .subtract(MESES_PERIODO_PADRAO - 1, "months")
      .startOf("month")
      .format("YYYY-MM"),
    dataFim: dayjs().format("YYYY-MM"),
  };
}
